import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { SimpleDataFilter } from '../models/simpleDataFilter';
import * as momentZ from 'moment-timezone';
import { FilteringIsActiveValues } from '../models/filtering';

@Injectable({
  providedIn: 'root'
})
export class FilteringService {
  filters = new Array<SimpleDataFilter>();
  constructor(public toast: ToastrService) { }

  public isActiveFilterValues : FilteringIsActiveValues[] = [
    { prettyValue: 'Yes', value: true },
    { prettyValue: 'No', value: false },
    { prettyValue: 'Either', value: null }
]


  public dateComparer(date1: moment.Moment, date2: moment.Moment, log: boolean = false): boolean {
    // create a new moment from the input date
    const newDate = moment(date2.toString());
    if (log) {
    }
    let ret = date1 <= newDate; 
    return ret;
  }

  clearTransientFilters(){
    var transientFilters = this.filters.filter(f=>{ return f.isTransient; });
    transientFilters.forEach(f => {
      this.filters.splice(this.filters.indexOf(f),1);
    });
  }

  stateArray : Array<string> = ['AL','AK','AZ','AR','CA','CO','CT','DC','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT',
  'NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];

  formatAsUTCLocal(date: Date, showTime: boolean): string {
    if(date == undefined || date == null) return null;
    var m = moment.utc(date);
    if (!m.isValid()) return null;
    if (showTime) {
      try {
        return m.local().format('M/D/YYYY:h:mm a');
      } catch (error) {
        console.warn('error parsing with time')
      }
    }  
    return m.local().format('M/D/YYYY');
  }

  public formatAsMST(date: Date, showTime: boolean): string {
    if(date == undefined || date == null) return null;
    var m = momentZ.utc(date);
    if (!m.isValid()) return null;
    if (showTime) {
      try {
        return m.tz('America/Denver').format('M/D/YYYY h:mm A z');
      } catch (error) {
        return 'INVALID DATE';
      }
    }

    try {
      let mt = momentZ.utc(date);
      let cnvrt = mt.tz('America/Denver');
      return cnvrt.format('M/D/YYYY z');
    } catch (error) {
      return 'INVALID DATE';
    }
  }

}
